module.exports = __webpack_public_path__ + "img/doc.193de27c.svg";